import { MixedLineBarChartProps } from '@amzn/awsui-components-core';

interface UserMetricsAggregatedData {
  totalApplicationViews: MixedLineBarChartProps.LineDataSeries<string | number | Date>[];
  uniqueUsersByApplication: MixedLineBarChartProps.LineDataSeries<string | number | Date>[];
  top5AppsViewership: MixedLineBarChartProps.LineDataSeries<string | number | Date>[];
  appViewershipByTeamData: MixedLineBarChartProps.BarDataSeries<string | number | Date>[];
}

export const aggregateUserMetricsSummaryData = (userMetricsData: UserMetricsAggregatedData) => {
  // Aggregate user metrics data for AI summary
  return {
    totalApplicationViews: userMetricsData.totalApplicationViews || [],
    uniqueUsersByApplication: userMetricsData.uniqueUsersByApplication || [],
    top5AppsViewership: userMetricsData.top5AppsViewership || [],
    appViewershipByTeam: userMetricsData.appViewershipByTeamData || []
  };
};
